import React from "react";
import "./footer.css";
const Footer = () => {
  return (
    <>
      <footer className="pt-4 mt-4 footer-container">
        <div className="container ">
          <div className="grid row d-flex flex-wrap justify-content-start">
            <div className="footer-list-container col-lg-3 col-12">
              <p style={{ fontWeight: "600" }}>Products</p>
              <ul className="fw-light footer-list">
                <li>
                  <a href="/platform-solutions">Platform Solutions</a>
                </li>
                <li>
                  <a href="/process-equipment">Process Equipment</a>
                </li>
                <li>
                  <a href="/advance-materials/eco-mask">
                    Advanced Materials
                  </a>
                </li>
                <li>
                  <a href="/automation-solutions">Automation Solutions</a>
                </li>
              </ul>
            </div>
            <div className="footer-list-container col-lg-3 col-12">
              <p style={{ fontWeight: "600" }}>Services</p>
              <ul className="fw-light footer-list">
                <li>
                  <a href="/available-soon">
                    Customized Software Solutions
                  </a>
                </li>
                <li>
                  <a href="/engineering-resources">Global Capability Center</a>
                </li>
                <li>
                  <a href="/available-soon">
                    Manufacturing Sub-Contract
                  </a>
                </li>
                <li>
                  <a href="/available-soon">Legacy Tool Conversion</a>
                </li>
                <li>
                  <a href="/post-warranty-services">
                    Post Warranty Service Packages
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-list-container col-lg-3 col-12">
              <p style={{ fontWeight: "600" }}>Resources</p>
              <ul className="fw-light footer-list">
                <li>
                  <a href="/press-releases">Press Releases</a>
                </li>
                <li>
                  <a href="/product-launches" >Product Launches</a>
                </li>
                <li>
                  <a href="/available-soon" >Knowledge Hub</a>
                </li>
                <li>
                  <a href="/available-soon" >Training Center</a>
                </li>
              </ul>
            </div>
            <div className="footer-list-container col-lg-3 col-12">
              <p style={{ fontWeight: "600" }}>Life at MindOx</p>
              <ul className="fw-light footer-list">
                <li>
                  <a href="/about-us">About Us</a>
                </li>
                <li>
                  <a href="/life-at-mindox/careers">Careers</a>
                </li>
              </ul>
            </div>
            <div className="col-lg-12 col-12 text-center mt-3">
              <p style={{ fontWeight: "600" }}>
                Want to know more or do you have a question?
              </p>
              <p className="fw-light footer-list">
                <span className="fw-medium">
                  <a href="/contact-sales" style={{ color: "#1d1f48" }}>
                    Book a demo
                  </a>
                </span>
                <br />
                Or you can reach out to us on workdays from 9am till 5pm.
                <br />
              
                Singapore +65 6983 8172
              </p>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row mt-2">
            <div className="text-center ">
              <p>
                <a
                  href="https://www.linkedin.com/company/mindoxtechno"
                  className="text-black ms-2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-linkedin"></i>
                </a>{" "}
                |
                {/* <a
                  href="https://www.x.com/"
                  className="text-black ms-2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-twitter-x"></i>
                </a>{" "}
                | */}
                <a
                  href="https://www.instagram.com/mindoxtechno/"
                  className="text-black ms-2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-instagram"></i>
                </a>{" "}
                |
                <a
                  href="https://www.facebook.com/profile.php?id=61562781852984"
                  className="text-black ms-2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-facebook"></i>
                </a>
              </p>
              <p style={{ fontSize: "0.8em" }}>
                &copy; 2025 MindOx Techno. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
